import { Badge, Stack } from '@chakra-ui/react'
import { useCallback, useRef } from 'react'
import {
  PAYMENT_TYPE_COLOR,
  PAYMENT_TYPE_ICON,
  PAYMENT_TYPE_LABEL,
  PAYMENT_STATE_COLOR,
  PAYMENT_STATE_LABEL,
  PAYMENT_TYPE_BADGE,
} from 'shared/constants/payments'
import { getDateTimeReadFormat, getDateTimeToSubmit } from 'shared/utils/dateFormatting'
import { Snippets, SnippetsHeading, SnippetsItem, SnippetsList } from 'uikit'
import { HeadingItem, ItemBadge, ItemIcon, ItemLink, ItemText } from 'uikit/Snippets'
import { ContentContainer, ContentContainerColumn } from 'uikit/layout'
import { PaymentsActions } from './elements/PaymentsActions'
import { PaymentsFilters } from './elements/PaymentsFilters'
import { useFetchPaymentsList } from './hooks/useFetchPaymentsList'

export const Payments = ({ user = {} }) => {
  const filtersRef = useRef()
  const { fetch, list, hasMore, fetchNextPage, isFetching } = useFetchPaymentsList(user.phone)

  const onChangeFilters = useCallback(
    (state) => {
      filtersRef.current = state

      const { paymentDateFrom, paymentDateTo, paymentState } = state

      fetch({
        paymentDateFrom: paymentDateFrom ? getDateTimeToSubmit(paymentDateFrom) : undefined,
        paymentDateTo: paymentDateTo ? getDateTimeToSubmit(paymentDateTo) : undefined,
        paymentState: paymentState !== 'all' || !paymentState ? paymentState : undefined,
        isFromUserPage: true,
      })
    },
    [user]
  )

  return (
    <ContentContainer templateColumns="minmax(600px, 2000px) 300px" gap="30px" pb={0}>
      <ContentContainerColumn>
        <Snippets
          columns="42px 180px 120px 120px minmax(150px, 1fr) 180px 180px 220px 200px 200px"
          itemWidth="1550px"
        >
          <SnippetsHeading>
            <HeadingItem />
            <HeadingItem>ID</HeadingItem>
            <HeadingItem>Сумма</HeadingItem>
            <HeadingItem>Комиссия</HeadingItem>
            <HeadingItem>Получатель</HeadingItem>
            <HeadingItem>Дата</HeadingItem>
            <HeadingItem>Источник</HeadingItem>
            <HeadingItem>Тип</HeadingItem>
            <HeadingItem>Статус</HeadingItem>
          </SnippetsHeading>
          <SnippetsList
            data={list}
            scrollableTarget="scrollableCardContainer"
            hasMore={hasMore}
            isLoading={isFetching}
            onNext={() => {
              fetchNextPage()
            }}
          >
            {(item) => (
              <SnippetsItem to={`/payments/show/0/${item.id}`}>
                <ItemIcon
                  IconComponent={PAYMENT_TYPE_ICON[item.paymentType]}
                  color={PAYMENT_TYPE_COLOR[item.paymentType]}
                  badge={PAYMENT_TYPE_BADGE[item.paymentType]}
                />
                <ItemText>{item.id}</ItemText>
                <ItemLink>
                  <b>{item.amount}</b>
                  <Badge
                    ml={2}
                    fontSize="0.7rem"
                    fontWeight="500"
                    verticalAlign="middle"
                    colorPalette="gray"
                  >
                    {item.currency}
                  </Badge>
                </ItemLink>

                <ItemLink>
                  <b>{item.commission}</b>
                  <Badge
                    ml={2}
                    fontSize="0.7rem"
                    fontWeight="500"
                    verticalAlign="middle"
                    colorPalette="gray"
                  >
                    {item.commissionCurrency}
                  </Badge>
                </ItemLink>
                <ItemText>{item.payeePhone}</ItemText>
                <ItemText>{getDateTimeReadFormat(item.paymentDate)}</ItemText>
                <ItemText>{item.paymentSource}</ItemText>
                <ItemText>{PAYMENT_TYPE_LABEL[item.paymentType]}</ItemText>
                <ItemText>
                  <ItemBadge colorPalette={PAYMENT_STATE_COLOR[item.state] || 'gray'}>
                    {PAYMENT_STATE_LABEL[item.state] || item.state}
                  </ItemBadge>
                </ItemText>
              </SnippetsItem>
            )}
          </SnippetsList>
        </Snippets>
      </ContentContainerColumn>
      <ContentContainerColumn>
        <Stack gap="24px" position="sticky" top="10px">
          <PaymentsFilters onChange={onChangeFilters} />
          <PaymentsActions user={user} filters={filtersRef.current} />
        </Stack>
      </ContentContainerColumn>
    </ContentContainer>
  )
}
